import { createSlice } from '@reduxjs/toolkit';
import {query, describe} from '../../services/salesforce'

export const locationSurveySlice = createSlice({

    // Slice name, this should be always as page name.
    name: 'locationSurvey',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null
    },

    // Reducers will mutate the state, put all the state mutation method over here 
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
})

export default locationSurveySlice.reducer

// Export all the reducers actions here
export const { initialize, error } = locationSurveySlice.actions;


// Public Selectors
export const selectLocationSurveyData = (state) => state.locationSurvey.data;
export const selectLocationSurveyStatus = (state) => state.locationSurvey.status;
export const selectLocationSurveyError = (state) => state.locationSurvey.error;

export const initializeAsync = (props) => async (dispatch) => {
    // const result = await query('account');
    // if(result.isSuccess){
    //     dispatch(initialize({records: result.data}));
    // }
    // else{
    //     dispatch(error(result.errorMessage))
    // }

    dispatch(initialize({}));
}

